/* Shared builder-to-quote handoff. Stores selections only, never contact details. */
(() => {
  'use strict';
  const KEY = 'cw_quote_handoff_v1';
  const sources = new Set(['Order Builder', 'Room Designer', 'Vanity Builder']);
  let opening = false;

  function open({ source, summary } = {}) {
    if (opening || !sources.has(source) || typeof summary !== 'string') return false;
    const text = summary.trim();
    if (!text || text.length > 60000) return false;
    let config;
    try {
      config = JSON.parse(document.getElementById('cw-quote-handoff-config')?.textContent || '{}');
      const destination = new URL(config.url, location.origin);
      if (destination.origin !== location.origin || !destination.pathname.endsWith('/pages/contact')) return false;
      destination.searchParams.set('view', 'quote');
      destination.searchParams.set('source', 'builder');
      const handoff = JSON.stringify({ version: 1, source, createdAt: new Date().toISOString(), summary: text });
      sessionStorage.setItem(KEY, handoff);
      if (sessionStorage.getItem(KEY) !== handoff) return false;
      opening = true;
      location.assign(destination.href);
      return true;
    } catch (_) {
      opening = false;
      return false;
    }
  }

  window.CastlewoodQuote = Object.freeze({ open });
  window.addEventListener('pageshow', () => { opening = false; });
})();
